import { AxiosResponse } from "axios"
import SecureClient from "../SecureClient"
import { BaseWorkflowTaskModel, BaseWorkflowTaskState, NewWorkflowTaskModel, WorkflowTaskPermissions, WorkflowTaskResponse, WorkflowTaskResult, WorkflowTaskState, WriteWorkflowTaskModel } from "./DTOs"

export default class WorkflowTasksClient extends SecureClient {

	/**
	 * Get one workflow task with optional parameter to read or write - write acquires a lock.
	 * Read is default
	 */
	
	public getWorkflowTask<TState extends BaseWorkflowTaskState>(
		workflowTaskId: number,
	): Promise<AxiosResponse<WorkflowTaskResponse<TState>>>;
	public getWorkflowTask<TState extends BaseWorkflowTaskState>(
		workflowTaskId: number,
		permission?: WorkflowTaskPermissions
	): Promise<AxiosResponse<WorkflowTaskResponse<TState>>>;
	public getWorkflowTask<TState extends BaseWorkflowTaskState>(
		workflowTaskId: number,
		permission: WorkflowTaskPermissions.Read
	): Promise<AxiosResponse<WorkflowTaskResponse<TState>>>;
	public getWorkflowTask<TState extends BaseWorkflowTaskState>(
		workflowTaskId: number,
		permission: WorkflowTaskPermissions.Write
	): Promise<AxiosResponse<WriteWorkflowTaskModel<TState>>>;
	public getWorkflowTask<TState extends BaseWorkflowTaskState> (
		workflowTaskId: number,
		permission?: WorkflowTaskPermissions,
	): Promise<AxiosResponse<WorkflowTaskResponse<TState>>> {
		return this._api.get<WorkflowTaskResponse<TState>>(
			`WorkflowTasks/${workflowTaskId}`,
			{
				headers: {
					...this.acceptHeader,
					...this.contentTypeHeader,
				},
				params: {
					permission,
				},
			},
		)
	}

	/**
	 * Get all workflow tasks for an organization
	 * @param workflowTaskState - optional - get all, locked, unlocked, active, or done workflow tasks
	 */
	public getWorkflowTasksForOrganization = (
		workflowTaskState?: WorkflowTaskState,
	): Promise<AxiosResponse<BaseWorkflowTaskModel[]>> => {
		return this._api.get<BaseWorkflowTaskModel[]>(
			`WorkflowTasks`,
			{
				headers: {
					...this.acceptHeader,
					...this.contentTypeHeader,
				},
				params: {
					workflowTaskState: workflowTaskState,
				},
			},
		)
	}

	public addWorkflowTask = (
		model: NewWorkflowTaskModel,
	): Promise<AxiosResponse<BaseWorkflowTaskModel>> => {
		return this._api.post(`WorkflowTasks`, model, {
			headers: {
				...this.acceptHeader,
				...this.contentTypeHeader,
			},
		})
	}

	/**
	 * renew a workflow task's lock
	 * @param workflowTaskId
	 * @returns the lock password for the specified workflow task
	 */
	public renewLock = (workflowTaskId: number): Promise<AxiosResponse<string>> => {
		return this._api.put(
			`WorkflowTasks/${workflowTaskId}/RenewLock`,
			{
				headers: {
					...this.acceptHeader,
					...this.contentTypeHeader,
				},
			},
		)
	}

	public completeWorkflowTask = (
		workflowTaskId: number,
		result: WorkflowTaskResult,
	): Promise<AxiosResponse<number>> => {
		return this._api.post(
			`WorkflowTasks/${workflowTaskId}/Complete`,
			result,
			{
				headers: {
					...this.acceptHeader,
					...this.contentTypeHeader,
				},
			},
		)
	}
}